import { render } from "./TheNewsItem.vue?vue&type=template&id=3b31422f&ts=true"
import script from "./TheNewsItem.vue?vue&type=script&lang=ts"
export * from "./TheNewsItem.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__